import React from 'react';
import { Layout } from 'antd';
import PropTypes from 'prop-types';
import Header from './layout/Header';
import FooterLayout from './layout/Footer';

function AppLayout({ children }) {
  const { Footer } = Layout;

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      {children}
      <Footer style={{ backgroundColor: 'black' }}>
        <FooterLayout />
      </Footer>
    </Layout>
  );
}

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppLayout;
